import { BrandMark } from "@diffex/ui";
import type { PropsWithChildren } from "react";

export function PublicLayout({ children }: PropsWithChildren) {
  return (
    <div className="public-page">
      <header>
        <BrandMark className="product-brand" />
      </header>
      <main className="public-card">{children}</main>
      <footer>Private preview</footer>
    </div>
  );
}
